import {
  Button,
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ResponsiveValue,
} from "@chakra-ui/react"
import { useTranslation } from "react-i18next";
import useWindowSize from "../utils/useWindowSize";

interface ModalProps {
  header: string;
  isOpen: boolean;
  onClose: () => void;
  secondaryActionName?: string;
  secondaryActionEnabled?: boolean;
  secondaryAction?: () => void;
  secondaryActionLoading?: boolean;
  secondaryActionLoadingText?: string;
  secondaryActionBtnType?: "button" | "submit" | "reset";
  children: JSX.Element[] | JSX.Element;
  additionalBtn?: JSX.Element[] | JSX.Element;
  size?: ResponsiveValue<"sm" | "md" | "lg" | "xl" | "2xl" | (string & {}) | "xs" | "3xl" | "4xl" | "5xl" | "6xl" | "full"> 
}

export interface SimpleModalControls {
  isOpen: boolean;
  onClose: () => void;
}

const Modal = (props: ModalProps) => {
  const { t } = useTranslation("translations");
  
  const { width } = useWindowSize();

  return (
    <ChakraModal isOpen={props.isOpen} size={width > 780 ? props.size : "full"} onClose={props.onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{props.header}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <form id='my-form' onSubmit={(e) => {
            e.preventDefault();
            if(props.secondaryAction) props.secondaryAction();
          }}>
            {props.children}
          </form>
        </ModalBody>

        <ModalFooter>
          {props.additionalBtn && props.additionalBtn}
          {
            props.secondaryAction && 
              <Button
                  form="my-form"
                  type={props.secondaryActionBtnType ? props.secondaryActionBtnType : "submit"}
                  isLoading={props.secondaryActionLoading}
                  loadingText={props.secondaryActionLoadingText ?? t('DEFAULT_LOADING_TEXT')}
                  isDisabled={!props.secondaryActionEnabled}
                  colorScheme='teal'
                  onClick={props.secondaryActionBtnType && props.secondaryActionBtnType !== "submit" ? props.secondaryAction : () => {}}
                  spinnerPlacement='end'
              >
                {props.secondaryActionName ?? 'Secondary action'}
              </Button>
          }

        </ModalFooter>
      </ModalContent>
    </ChakraModal>
  )
}

export default Modal;